var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.874023,
    y: 0.136108,
    width: 20.9496,
    height: 20.9496,
    rx: 3.9904,
    fill: "#21D4FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3726 5.1247C16.4977 5.11825 16.6196 5.16534 16.7078 5.25419C16.796 5.34292 16.8422 5.46494 16.8351 5.58981C16.4854 11.7393 11.0109 14.0473 10.9558 14.0697C10.7917 14.1368 10.6034 14.099 10.4779 13.9737L7.9862 11.4821C7.86155 11.3573 7.82342 11.1701 7.8893 11.0064C7.91132 10.9509 10.1938 5.44711 16.3726 5.1247ZM12.1507 10.2858C12.4799 10.4221 12.8588 10.3467 13.1107 10.0947C13.4546 9.7507 13.4546 9.1931 13.1107 8.84911C12.8588 8.59712 12.4799 8.5217 12.1507 8.65803C11.8215 8.79436 11.6068 9.11559 11.6068 9.4719C11.6068 9.82821 11.8215 10.1494 12.1507 10.2858Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4198 13.5242C6.77926 13.1635 7.3048 13.0219 7.79766 13.1529C8.29053 13.2839 8.67549 13.6675 8.80695 14.1587C8.93841 14.6498 8.79631 15.1735 8.43439 15.5317C7.8779 16.0862 5.8623 16.0977 5.8623 16.0977C5.8623 16.0977 5.8623 14.0782 6.4198 13.5242Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.59854,
    d: "M10.8503 6.19087C9.63047 5.9302 8.38372 6.41552 7.50906 7.49149C7.281 7.77411 7.08272 8.09074 6.91886 8.43397C6.82017 8.63972 6.84736 8.9014 6.98496 9.07014L7.83316 10.1121C8.62133 8.57629 9.64621 7.24428 10.8503 6.19087V6.19087Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.59854,
    d: "M15.7691 11.1097C16.0298 12.3295 15.5445 13.5763 14.4685 14.4509C14.1859 14.679 13.8693 14.8773 13.526 15.0411C13.3203 15.1398 13.0586 15.1126 12.8899 14.975L11.8479 14.1268C13.3837 13.3386 14.7157 12.3138 15.7691 11.1097V11.1097Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.07ef62eb.svg";
export { ForwardRef as ReactComponent };